import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › SalesInbox (leaf).
export const salesInbox: ContentPage = {
  slug: "sales-enablement/salesinbox",
  template: "hrmsFeature",
  seo: {
    title: "SalesInbox - CRM-Powered Email for Reps | GetBiz CRM",
    description: "Bring email into the CRM with GetBiz SalesInbox. See deal context beside every message, prioritize by pipeline and log replies automatically.",
    keywords: ["sales inbox", "crm email", "email in crm", "sales email management"],
    ogImage: "/assets/data/seoimages/salesinbox.webp",
  },
  leaf: {
    hero: {
      caption: "SalesInbox",
      title: "Your Inbox, Powered by Your CRM",
      description: "Work email inside the CRM with full deal context beside every message — prioritize, reply and log without switching apps.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose SalesInbox",
      bullets: [
        { title: "Context Beside Email", description: "See the related deal next to each message." },
        { title: "Prioritize by Pipeline", description: "Surface emails from your biggest deals first." },
        { title: "Auto-Log", description: "Every email logs to the right contact." },
        { title: "Reply in Place", description: "Respond without leaving the CRM." },
      ],
      image: "/assets/images/img/product/crm/salesinbox-lead-image.webp",
      imageAlt: "SalesInbox — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "SalesInbox connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See SalesInbox in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-salesinbox",
  },
  sections: [],
};
